import React, {useContext} from "react";
import AuthContext from "../../context/AuthContext";
import PropTypes from "prop-types";
import yesIcon from "../../assets/icons/yes.svg";
import noIcon from "../../assets/icons/no.svg";
import orangeIcon from "../../assets/icons/orange.svg";
import Button from "../Button/Button";
import {useNavigate} from "react-router-dom";
import useBookable from "../../hooks/useBookable";
import SpotGroupIcon from "../../assets/icons/spot-group-white.svg";
import StandIcon from "../../assets/icons/stand-white.svg";
import BoostIcon from "../../assets/icons/profile-boost.svg"
import settingsIcon from "../../assets/icons/cog.svg";
import useFunction from "../../hooks/useFunction";
import profileBoostIcon from "../../assets/icons/profile-boost-white.svg";

const ProfileStatus = (props) => {

  const {
    model,
    showSettingButton = false,
  } = props

  const {user} = useContext(AuthContext)
  const {getUserActiveCompanyErrors, getModelErrors, getSolutionUrl, getBookableStatus} = useBookable()
  const navigate = useNavigate()
  const {isSpotGroup} = useBookable()
  const companyErrors = getUserActiveCompanyErrors(user)
  const modelErrors = getModelErrors(model)
  const {isStand} = useBookable()
  const bookableStatus = getBookableStatus(model)
  const {objIsEmpty} = useFunction()

  /**
   * Error component
   * @param props
   * @returns {JSX.Element}
   * @constructor
   */
  const Error = (props) => {
    const {error, onClick, showButton} = props
    return (
      <div className="error">
        <img className="status-icon" src={noIcon} alt="status"/>
        <div className="message">{error.message}</div>
        {showButton &&
          <Button
            label="Aanpassen"
            size="s"
            onClick={(onClick) ? onClick : null}
          />
        }
      </div>
    )
  }

  /**
   *
   * @returns {*}
   */
  const getPublicErrorButtonUrl = () => {
    return getSolutionUrl((isSpotGroup(model)) ? 'spot_group_public' : 'stand_public', (!objIsEmpty(user) && user.active_company) ? user.active_company : null, model)
  }

  /**
   * @returns {string}
   */
  const getLink = () => {
    return (isSpotGroup(model))
      ? '/locatie/' + model.slug
      : '/stand/' + model.slug
  }

  return (
    <div className="component-profile-status">
      {model.public ?
        <>
          {!!companyErrors.length || !!modelErrors.length
            ?
            <>
              <h3>Dit profiel is nu niet voor anderen zichtbaar</h3>
              <p>Om het profiel zichtbaar en boekbaar te maken voor iedereen, vul de volgende gegevens aan:</p>
              {!!companyErrors.length &&
                <>
                  <p>
                    {!objIsEmpty(user) && 'active_company' in user && user.active_company && user.active_company.company.type === 'commercial' && 'Bedrijf: '}
                    {!objIsEmpty(user) && 'active_company' in user && user.active_company && user.active_company.company.type === 'non-official' && 'Account: '}
                    {!objIsEmpty(user) && 'active_company' in user && user.active_company && user.active_company.company.type === 'public' && 'Organisatie: '}
                    {!objIsEmpty(user) && 'active_company' in user && user.active_company && user.active_company.company.type === 'non-profit' && 'Non-profit: '}
                    {!objIsEmpty(user) && 'active_company' in user && user.active_company && user.active_company.legal_name}</p>
                  <div className="errors company-errors">
                    {companyErrors.map((error, i) => {
                      const solutionUrl = getSolutionUrl(error.key, (!objIsEmpty(user) && user.active_company) ? user.active_company : null, model)
                      return (<Error
                        key={i}
                        error={error}
                        showButton={solutionUrl}
                        onClick={() => navigate(solutionUrl)}
                      />)
                    })}
                  </div>
                </>
              }
              {!!modelErrors.length &&
                <>
                  <p>{(isSpotGroup(model)) ? 'Locatie:' : 'stand of truck:'}</p>
                  <div className="errors model-errors">
                    {modelErrors.map((error, i) => {
                      const solutionUrl = getSolutionUrl(error.key, (!objIsEmpty(user) && user.active_company) ? user.active_company : null, model)
                      return (<Error
                        key={i}
                        error={error}
                        showButton={solutionUrl}
                        onClick={() => navigate(solutionUrl)}
                      />)
                    })}
                  </div>
                </>
              }
            </>
            :
            <>
              <div className="no-error">
                {bookableStatus.key === 'not-public' &&
                  <div className="row">
                    <img className="status-icon" src={orangeIcon} alt="status"/>
                    <p>Profiel niet openbaar, wel beschikbaar voor boekingen</p>
                  </div>
                }
                {bookableStatus.key === 'not-bookable' &&
                  <div className="row">
                    <img className="status-icon" src={noIcon} alt="status"/>
                    <p>Profiel niet openbaar en niet beschikbaar</p>
                  </div>
                }
                {bookableStatus.key === 'bookable' &&
                  <div className="row">
                    <img className="status-icon" src={yesIcon} alt="status"/>
                    <p>Profiel openbaar en beschikbaar</p>
                  </div>
                }
                {bookableStatus.key === 'closed' &&
                  <div className="row">
                    <img className="status-icon" src={orangeIcon} alt="status"/>
                    <p>Profiel openbaar, maar (tijdelijk) gesloten voor boekingen, en niet zichtbaar in
                      zoekresultaten.</p>
                  </div>
                }
                <div className="row action-buttons">
                  <Button
                    label="Bekijk profiel"
                    link={getLink()}
                    target='_blank'
                    icon={isSpotGroup(model) ? SpotGroupIcon : StandIcon}
                  />
                  {bookableStatus.key === 'bookable' &&
                    <>
                      {model.has_active_profile_boost === true
                        ? <img src={BoostIcon} alt="Profiel is nu omhoog omhoog geplaatst" width={50}/>
                        : <Button
                          label="Plaats profiel omhoog"
                          link="/user/profile-boosts"
                          color="blue"
                          icon={profileBoostIcon}
                        />
                      }
                    </>
                  }
                  {showSettingButton &&
                    <Button
                      label="Instellingen"
                      color="grey-ghost"
                      link={isSpotGroup(model) ? '/user/locatie/' + model.id + '/edit' : '/user/stand/' + model.id + '/edit'}
                      icon={settingsIcon}
                    />
                  }
                </div>
              </div>
            </>
          }
        </>
        :
        <div>
          <h3>Profiel is verborgen</h3>
          <p>Dit profiel wordt niet weergegeven in de zoekresultaten en is dus niet door anderen te boeken.</p>
          <p>Het profiel is wel zichtbaar voor {isStand(model) ? 'locatie' : 'Stands of Truck'} eigenaren waar jij
            boekingsaanvragen naartoe stuurt</p>
          <p>Je kan zelf ook {isStand(model) ? 'locaties' : 'Stands of Trucks'} vinden en boeken met
            deze {isStand(model) ? 'stand of truck' : 'locatie'}.</p>
          <div className="errors">
            <Error
              error={{key: 'public', message: 'Profiel verborgen'}}
              showButton={getPublicErrorButtonUrl()}
              onClick={() => navigate(getPublicErrorButtonUrl())}
            />
          </div>
        </div>
      }
    </div>
  )
}

ProfileStatus.propTypes = {
  model: PropTypes.object.isRequired,
  showSettingButton: PropTypes.bool,
}

export default ProfileStatus



















